import React, { useState, useEffect, memo } from 'react';
import {Modal, ThemeProvider, ModalWrapper, ModalHeader, ModalContent} from '@workboard/wobo-ui';
import { useTranslation } from 'react-i18next';
import { RadioButComp } from './inputs/fields.component';

import styled from "styled-components"
const StyledModal = styled(Modal)`
  ${ModalWrapper} {
    width: 874px;
  }
  ${ModalHeader} {
    padding: 10px 20px !important;
    h1 {
      height: 24px !important;
      left: 24px !important;
      right: 76px !important;
      bottom: 16.04px !important;
      font-style: normal;
      font-weight: 700 !important;
      font-size: 24px !important;
      line-height: 24px !important;
      letter-spacing: 0.15px;
      color: #333943;
    }
  }
  ${ModalContent} {
    padding: 10px 27px !important;
    p {
       line-height: 1.5;
       margin: 0;
    }
    .contentHead{
      width: 817.48px !important;
      height: 48.54px !important;
      font-style: normal !important;
      font-weight: 400 !important;
      font-size: 18px !important;
      line-height: 20px !important;
      letter-spacing: 0.15px !important;
      color: #333943;
    }
    .noteContainer{
      font-style:italic !important;
      padding:27px 22px 20px 6px !important
    }
    .react-radio{
      width:20px;
      height:20px;
    }
`;

const RetainUpdateModal = ({
  selectedType,
  changeRadio,
  exitDeleteModal,
  deleteItems,
  titleRetain,
  contentRetain
} = props) => {

  const [message, setMessage] = useState('')
  const { t } = useTranslation();
  const options = [
    {
      id: '2',
      label: `${t('Retain all historical key result updates')}`
    },
    {
      id: '1',
      label: `${t('Remove all historical key result updates and start fresh')} `
    }    
  ];
  
  const deleteSubmit = (e) => {
    e.persist();
		e.stopPropagation();
		e.preventDefault();
    if(selectedType != undefined && selectedType != ''){
      deleteItems();
    }else {
			setMessage(`${t('Please choose any one')}`)
		}
  }


  return (
    <ThemeProvider>
        <StyledModal
          className="delete-comment"
          dismissLabel={t("Cancel")}
          isDanger
          isOpen={true}
          onDismiss={exitDeleteModal}
          onClose={exitDeleteModal}
          onSubmit={(e) => deleteSubmit(e)}
          title={titleRetain}
          submitLabel={t('Save')}
          tabIndex="0"
        >
          <div style={{ height: "208px" }}>
            <div className='contentHead'>{contentRetain}</div>
            { options.map((option, index) => 
              <div className="radio-container">
                  <div className="kr-radios"
                    onClick={() => changeRadio(option.id)}
                  >
                    <RadioButComp 
                      id={option.id}
                      onClick={
                        changeRadio
                      }
                      
                      selectedClass={
                        selectedType === option.id
                      }
                      checked={(index == 0 ? true : false)}
                      label={option.label}
                      tabIndex={index}
                      radioButProps={
                          {
                            name:"retainType",
                            defaultChecked: selectedType === option.id,
                            tabIndex:0
                          }
                      }/>
                  </div>              
            </div>
                    )}
            <div className="noteContainer" >{t('Note')}: {t('Retaining all updates will result in old update cells appearing in your key result update page and charts.')}</div>
            {
						  message && 
                <div style={{color: '#d93630'}} >
                  {message}
                </div>
            }
          </div>
        </StyledModal>
    </ThemeProvider>
  )
}
export default RetainUpdateModal;